(function () {
  let enviando_formulario = false;

  // CADASTRAR / EDITAR
  $("#form-anuncio").on("submit", function (e) {
    e.preventDefault();

    var obj = this;
    var form = $(obj);
    var submit_btn = form.find("#cadastrar");
    var submit_btn_text = submit_btn.text();
    var dados = new FormData(obj);

    function volta_submit() {
      submit_btn.attr("disabled", false);
      submit_btn.text(submit_btn_text);
      enviando_formulario = false;
      hideLoading();
    }

    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          showLoading();
          enviando_formulario = true;
          submit_btn.attr("disabled", true);
          submit_btn.text("Aguarde...");
        },
        success: function (response) {
          console.log(response);
          response = JSON.parse(response);
          if (response.status == "ok") {
            window.location.href = response.url;
          } else {
            volta_submit();
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        },
      });
    }
  });

  // REMOVE ANÚNCIO
  $("#form-remove-anuncio").on("submit", function (e) {
    e.preventDefault();
    var obj = this;
    var form = $(obj);
    var dados = new FormData(obj);
    var idRemove = $("#id_remove").val();
    function volta_submit() {
      enviando_formulario = false;
      hideLoading();
    }
    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          closeModal("modal-confirm");
          showLoading();
          enviando_formulario = true;
        },
        success: function (data) {
          //console.log(data);
          volta_submit();
          data = JSON.parse(data);
          if (data.status == "ok") {
            $("#id_remove").val("");
            showAlert("Sucesso", "Removido com sucesso.", "success");
            setTimeout(() => {
              location.reload();
            }, 2000);
          } else {
            volta_submit();
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        },
      });
    }
  });

  // STATUS AVALUCAO
  $("#form-status-avaliacao").on("submit", function (e) {
    e.preventDefault();
    var obj = this;
    var form = $(obj);
    var dados = new FormData(obj);
    function volta_submit() {
      enviando_formulario = false;
      hideLoading();
    }
    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          closeModal("modal-status");
          showLoading();
          enviando_formulario = true;
        },
        success: function (data) {
          //console.log(data);
          volta_submit();
          //data = JSON.parse(data);
          if (data == "ok") {
            $("#id_remove").val("");
            showAlert("Sucesso", "Status alterado com sucesso.", "success");
            setTimeout(() => {
              location.reload();
            }, 2000);
          } else {
            volta_submit();
            showAlert(
              "Erro",
              "Não foi possível realizar essa operação.",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert(
            "Erro",
            "Não foi possível realizar essa operação.",
            "error"
          );
          console.log("ajax error response type " + type);
        },
      });
    }
  });
})();
